import React from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { ContactButton } from 'components/UI/Buttons';

import useIsMobile from '../../../hooks/useIsMobile';

const ClientLogo = styled('img')({
  width: '140px',
  height: '60px',
  objectFit: 'contain',
  maxWidth: '100%',
});

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '80px',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.08)',
  padding: theme.spacing(2),
  margin: '0 auto',
}));

const ZellerClients: React.FC = () => {
  const { isMobile } = useIsMobile();
  const clients = [
    { name: 'Salfa', logo: '/landing/clients/salfa.png', href: 'https://salfa.cl/' },
    { name: 'Aventura', logo: '/landing/clients/aventura.png', href: 'https://aventuramotors.cl/' },
    { name: 'Checkeados', logo: '/landing/clients/checkeados.png', href: 'https://www.checkeados.cl/' },
    { name: 'Rosselot', logo: '/landing/clients/rosselot.png', href: 'https://www.rosselot.cl/' },
    { name: 'Salfa Sur', logo: '/landing/clients/salfa-sur.png', href: 'https://www.salfasur.cl/' },
    { name: 'Astara', logo: '/landing/clients/astara.png', href: 'https://astara.com/es' },
    { name: 'Daniel Achondo', logo: '/landing/clients/daniel-achondo.png', href: 'https://danielachondo.cl/' },
    { name: 'Dumay', logo: '/landing/clients/dumay.png', href: 'https://www.dumay.cl/' },
    { name: 'Pompeyo', logo: '/landing/clients/pompeyo.png', href: 'https://www.pompeyo.cl/' },
    { name: 'Auto.cl', logo: '/landing/clients/autocl.png', href: 'https://www.auto.cl/' },
  ];

  return (
    <Box sx={{ py: 8, bgcolor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <Typography
          component="h2"
          variant="h3"
          align="center"
          color="text.primary"
          gutterBottom
          sx={{ fontWeight: 'bold', mb: 6 }}
        >
          Concesionarios líderes ya confían en Zeller
        </Typography>

        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="center"
          sx={{
            px: { xs: 0, md: 4 },
            mx: 'auto',
            width: '100%',
            '& .MuiGrid-item': {
              display: 'flex',
              justifyContent: 'center',
            },
          }}
        >
          {clients.map((client) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={isMobile ? 4 : 2.4}
              key={client.name}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <LogoContainer>
                <a href={client.href} target="_blank" rel="noopener noreferrer">
                  <ClientLogo src={client.logo} alt={`${client.name} logo`} loading="lazy" />
                </a>
              </LogoContainer>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Box display="flex" justifyContent="center" mt={4}>
        <ContactButton
          variant="contained"
          size="large"
          onClick={() => window.open('https://zcal.co/i/O1PPkO_D', '_blank', 'noopener,noreferrer')}
        >
          Agenda una demo
        </ContactButton>
      </Box>
    </Box>
  );
};

export default ZellerClients;
